import antdEnUS from "antd/es/locale/en_US";
import antdZhCn from "antd/es/locale/zh_CN";
import antdFrFR from "antd/es/locale/fr_FR";
import antdJaJP from "antd/es/locale/ja_JP";
import en from "./locales/en_US.json";
import zh from "./locales/zh_CN.json";
import fr from "./locales/fr_FR.json";
import ja from "./locales/ja_JP.json";
import hiWeb from "./locales/hi.json";
import enWeb from "./locales/en.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { THEME_CONFIG } from "configs/AppConfig";

export const resources = {
  en: {
    translation: { ...en, ...enWeb },
    antd: antdEnUS,
  },
  // antd hi_IN broken in this antd version — use en_US for antd UI only
  hi: {
    translation: hiWeb,
    antd: antdEnUS,
  },
  zh: {
    translation: zh,
    antd: antdZhCn,
  },
  fr: {
    translation: fr,
    antd: antdFrFR,
  },
  ja: {
    translation: ja,
    antd: antdJaJP,
  },
};

const defaultLng = THEME_CONFIG.locale || "hi";

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: defaultLng,
  lng: defaultLng,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
